import React, { Component } from "react";
import {Form, Button, Container, Row, Col, Alert} from "react-bootstrap";
import {Jumbotron} from "../helpers/Jumbotron";
import Axios from 'axios';
import {withRouter} from "../helpers/withRouter";
import Footer from "../Footer";

class AddMetroMedia extends Component{
    state = {
       campaign: {},
    };
    onSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        let data = new FormData();
        data.append("trainLine",form["trainLine"].value);
        data.append("4wk-mc",form["4wk-mc"].value);
        data.append("4wk-im",form["4wk-im"].value);
        data.append("imgUrl",form["imgUrl"].value);
        data.append("campaignId",this.state.campaign._id);
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/add-metro-media", data,{
            headers: {
                'content-type': 'multipart/form-data'
            }
        }).then(response => {
            form.reset();
            this.setState({metroMediaAddedSuccess:true});
        }).catch(error => {
            this.setState({metroMediaAddedError:error.response.data.message});
        });
    };
    dismissAlerts = (event) => {
        this.setState({metroMediaAddedError:undefined, metroMediaAddedSuccess:undefined})
    }

    componentDidMount() {
        this.getCampaignAPI()
    }

    getCampaignAPI(){
        let campaignId = this.props.match.params.campaignId;
        // let campaignId = this.props.match.params.campaignId;
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/campaign/"+campaignId).then((response) => {
            if(response.data.message === "still looking"){
                setTimeout(()=>{
                    this.getCampaignAPI();
                },3000);
            }else{
                this.setState({campaign: response.data.campaign});
            }
        }).catch(error => {
            console.log(error);
            if(error && error.response){
                this.setState({campaignGetError:error.response.data.message});
            }
        });
    }

    render() {
        const metroMediaAddedSuccess = this.state.metroMediaAddedSuccess;
        const metroMediaAddedError = this.state.metroMediaAddedError;
        return<div className={"main-content"}>
        <Container>
            <Jumbotron style={{maxWidth:500}} className={"mx-auto mt-5"}>
                <Form onSubmit={this.onSubmit}>
                    <Row>
                        <Col>
                            <h2>Add Train Media</h2>
                        </Col>
                    </Row>
                    <Row className={"mt-3"}>
                        <Col>
                            <Form.Group controlId="trainLine" >
                                <Form.Label>Train</Form.Label>
                                <Form.Control as="select" custom required>
                                    <option/>
                                    <option>Blue Line</option>
                                    <option>Gold Line</option>
                                    <option>Green Line</option>
                                    <option>Purple Line</option>
                                    <option>Red Line</option>
                                </Form.Control>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className={"mt-3"}>
                        <Col>
                            <Form.Group controlId="4wk-mc" >
                                <Form.Label>4-Wk Media Cost</Form.Label>
                                <Form.Control type="number" required/>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="4wk-im" >
                                <Form.Label>4-Wk Impressions</Form.Label>
                                <Form.Control type="number" required/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="imgUrl" >
                                <Form.Label>Image URL</Form.Label>
                                <Form.Control type="text"/>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className={"mt-4"}>
                        <Col>
                            <Button variant="primary" type={"submit"}>
                                + Add
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Jumbotron>
            {metroMediaAddedSuccess ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"} variant="success" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Uploading to Campaign:</Alert.Heading>
                    <p>Success: Media is uploading. It will take a few minutes to
                        gather compliance and insights on your media.</p>
                </Alert>
            ):(
                <></>
            )}
            {metroMediaAddedError ? (
                <Alert style={{maxWidth:500}} className={"mx-auto"}  variant="danger" onClose={this.dismissAlerts} dismissible>
                    <Alert.Heading>Error Uploading to Campaign!</Alert.Heading>
                    <p>Server Reported an Error: {metroMediaAddedError}. Please try again.</p>
                </Alert>
            ):(
                <></>
            )}
            <div className={"mx-auto mt-5"}>
            </div>
            <Footer/>
        </Container>
        </div>
    }
}

export default withRouter(AddMetroMedia);
